import { useState, Fragment, useRef } from "react";

import { Link, useLocation, withRouter, useHistory } from "react-router-dom";
import { ROLE_TYPES } from "./../../../../helpers/roleTypes";
import useAnInvestmentProduct from "../../../../custom-hooks/useAnInvestmentProduct";
import useInvestmentInterest from "../../../../custom-hooks/useInvestmentInterest";
import useEachInvestments from "../../../../custom-hooks/useEachInvestments";
// Redux
import { connect } from "react-redux";
import BackButtonComponent from "../../../../NewComponents/BackButton/BackButton.component";
import ButtonLoader from "../../../../UI/Loaders/Loaders";
import CreateInvestmentModal from "../../CreateInvestmentProducts/CreateInvestmentModal/CreateInvestmentModal";
import {
  postDataWithDotNet,
  putDataWithDotNet,
} from "../../../../newApis/dotNetApiMethods";
import * as ajaxEndpoints from "../../../../api/ajax-endpoints";
import { errorHandler } from "../../../../helpers/errorHandler";
import Alert from "../../../../NewComponents/Alert/Alert.component";
import { appInsights } from "../../../../config/appInsights";
import CustomSearchDropDown from "../../../CustomHTMLElements/CustomSearchDropDown/CustomSearchableDropdown";
import InvestmentFundDetails from "./Tabs/InvestmentFundDetails";

const ActiveInvestmentTab = (props) => {
  const [modalActionType, setModalActionType] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(null);
  const [saveError, setSaveError] = useState(null);
  const [investRateId, setInvestRateId] = useState(null);
  const [tenantId, setTenantId] = useState(null);
  const [selectedFundCurrency, setSelectedFundCurrency] = useState("");

  const dismissModalRef = useRef();
  const location = useLocation();
  const history = useHistory();
  const { id, from } = location?.state;

  const {
    data: investmentData,
    status: investmentStatus,
    isError: isEachInvestmentError,
  } = useEachInvestments(id);
  const { data, status, error } = useAnInvestmentProduct(id);

  const { data: investInterest } = useInvestmentInterest({
    id: investRateId,
    tenantId,
  });

  const [state, setState] = useState({
    funder_id: "",
    cba_wallet_account_id: "",
    investment_product_id: data?.id || "",
    cba_product_id: "",
    cba_product_interest_id: "",
    principal_amount: null,
    interest_rate: "",
    tenure: "",
    currency: "",
    interest_repayment_type: "",
    number_of_days_in_year: "",
    effective_date: null,
    transactionReceiptBase64: "",
    transactionReceiptName: "",
  });
  const [activateState, setActivateState] = useState({
    otp: "",
    comment: "",
  });

  const resetState = () => {
    setState({
      funder_id: "",
      cba_wallet_account_id: "",
      investment_product_id: data?.id || "",
      cba_product_id: "",
      cba_product_interest_id: "",
      principal_amount: null,
      interest_rate: "",
      tenure: "",
      currency: "",
      interest_repayment_type: "",
      effective_date: null,
      transactionReceiptBase64: "",
      transactionReceiptName: "",
    });
  };
  const handleDeactivation = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await putDataWithDotNet(
        `${ajaxEndpoints.FUNDER_INVESTMENT_PRODUCT}/${Number(id)}/deactivate`,
        activateState
      );
      setLoading(false);
      if (dismissModalRef && dismissModalRef.current) {
        dismissModalRef.current.click();
      }
      setSuccessMessage(response.message);
      resetState();

      setTimeout(() => {
        history.push("/investments");
      }, 3000);
    } catch (error) {
      appInsights.trackException({
        exception: error,
        properties: {
          fileName: "ActiveInvestmentTab.jsx",
        },
      });
      setLoading(false);
      if (dismissModalRef && dismissModalRef.current) {
        dismissModalRef.current.click();
      }
      setSaveError(errorHandler(error));
      resetState();
    }
  };

  const logInvestment = async (reqBody) => {
    try {
      const response = await postDataWithDotNet(
        `${ajaxEndpoints.LOG_INVESTMENT}`,
        reqBody
      );
      setLoading(false);
      if (dismissModalRef && dismissModalRef.current) {
        dismissModalRef.current.click();
      }
      setSuccessMessage(response.message);
      setTimeout(() => {
        history.goBack();
      }, 3000);
    } catch (error) {
      appInsights.trackException({
        exception: error,
        properties: {
          fileName: "EditInvestmentProduct.jsx",
        },
      });
      setLoading(false);
      if (dismissModalRef && dismissModalRef.current) {
        dismissModalRef.current.click();
      }
      setSaveError(errorHandler(error));
      setTimeout(() => {
        setSaveError(null);
      }, 3000);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setActivateState({ ...activateState, [name]: value });
  };
  const handleCurrency = (value) => {
    const productDetails = data?.investment_product_details.find(
      (item) => item?.currency_code === value
    );

    setTenantId(productDetails?.core_banking_tenant_id);
    setInvestRateId(productDetails?.core_banking_product_id);
  };
  const handleChangedState = (e) => {
    const { name, value } = e.target;
    setState({ ...state, [name]: value });
  };

  const handleChangeFund = (item) => {
    setSelectedFundCurrency(item?.value);
  };

  const getDefaultOptions = (arrayInQuestion) => {
    if (arrayInQuestion && arrayInQuestion.length > 0) {
      let result = arrayInQuestion.map((item) => {
        return {
          label: item,
          value: item,
        };
      });

      return result;
    }

    return [];
  };

  return (
    <Fragment>
      <div className="animated fadeInRight">
        <div className="d-flex flex-row flex-wrap mt-2 mb-1">
          {saveError && <Alert message={saveError} />}
          {successMessage && <Alert message={successMessage} type="success" />}
          <h3 className="page-title d-flex align-items-center">
            <BackButtonComponent />{" "}
            {status === "loading" ? (
              <ButtonLoader />
            ) : !error && data ? (
              data.name
            ) : (
              ""
            )}
          </h3>
          <div className="flex-row mt-2 mb-1">
            {props.loggedInUser.roleTypes.includes(
              ROLE_TYPES.INVESTMENT_PRODUCT_APPROVER
            ) && from === "active" ? (
              <button
                type=""
                className="btn advancly-dimred-btn btn-md m-0"
                disabled={loading}
                data-toggle="modal"
                data-target="#createInvestmentModal"
                onClick={() => setModalActionType("deactivate")}
              >
                Deactivate Fund
              </button>
            ) : (
              ""
            )}
            {props.loggedInUser.roleTypes.includes(
              ROLE_TYPES.INVESTMENT_PRODUCT_APPROVER
            ) || from === "inactive" ? (
              ""
            ) : (
              <Link
                to={{
                  pathname: `/investments/${id}/edit`,
                  state: {
                    data: data,
                    editType: "active",
                  },
                }}
              >
                <button
                  type=""
                  className="btn advancly-btn btn-md mr-3"
                  disabled={!data}
                >
                  Edit
                </button>
              </Link>
            )}
            {props.loggedInUser.roleTypes.includes(
              ROLE_TYPES.INVESTMENT_PRODUCT_APPROVER
            ) || from === "inactive" ? (
              ""
            ) : (
              <button
                type=""
                className="btn advancly-btn btn-md m-0"
                disabled={loading}
                data-toggle="modal"
                data-target="#createInvestmentModal"
                onClick={() => {
                  setModalActionType("step1");
                }}
              >
                Log Investment
              </button>
            )}
          </div>
        </div>

        <div className="w-100">
          <div className="col-4 mb-3">
            <CustomSearchDropDown
              placeholder="Select Currency"
              onChange={handleChangeFund}
              defaultOptions={getDefaultOptions(investmentData?.currencies)}
              name="fund_currencies"
              isShowLabel={false}
              isMulti={false}
              isSearchable={false}
            />
          </div>
        </div>

        <hr />

        {isEachInvestmentError ? (
          <div className="centerLoader">
            <div className="mt-40 tfx-user-form-wrapper box-effect full-border white-bg animated fadeInRight">
              <h4 className="center-txt p-y-5">
                <i className="fas fa-bell" /> Unable to fetch Investment fund
                details
              </h4>
            </div>
          </div>
        ) : (
          <>
            {!selectedFundCurrency && (
              <div className="centerLoader">
                <div className="mt-40 tfx-user-form-wrapper box-effect full-border white-bg animated fadeInRight">
                  <h4 className="center-txt p-y-5">
                    <i className="fas fa-bell" /> No currency has been selected.
                    Please select currency
                  </h4>
                </div>
              </div>
            )}

            {selectedFundCurrency && (
              <InvestmentFundDetails
                investmentData={investmentData}
                selectedFundCurrency={selectedFundCurrency}
              />
            )}
          </>
        )}
      </div>
      <CreateInvestmentModal
        onSubmit={handleDeactivation}
        modalActionType={modalActionType}
        dismissModalRef={dismissModalRef}
        loading={loading}
        handleChange={handleChange}
        state={state}
        setState={setState}
        logInvestment={logInvestment}
        data={data}
        setModalActionType={setModalActionType}
        handleChangedState={handleChangedState}
        setLoading={setLoading}
        resetState={resetState}
        handleCurrency={handleCurrency}
        investInterest={investInterest}
        investRateId={investRateId}
        tenantId={tenantId}
      />
    </Fragment>
  );
};

const mapStateToProps = (state) => {
  const { loggedInUser } = state.authReducer;

  return {
    loggedInUser,
  };
};

export default withRouter(connect(mapStateToProps)(ActiveInvestmentTab));
